<div class="row">
  <div class="secondary-details col-sm-6 mb-2 mt-2">
    <ng-container *ngIf="responseLoaded">
      <span *ngIf="looseBbx && !pieceLevelLabelPrint">{{
        'shipment.shipmentList.looseBbxBabyShipments' | translate
      }}</span>
      <span *ngIf="!pieceLevelLabelPrint && !looseBbx"
        >{{ 'shipment.shipmentList.babyShipments' | translate }}
      </span>
      <span *ngIf="pieceLevelLabelPrint && !looseBbx">{{
        'shipment.shipmentList.pieces' | translate
      }}</span>
      <span *ngIf="looseBbx && pieceLevelLabelPrint">{{
        'shipment.shipmentList.looseBbxPieces' | translate
      }}</span>
    </ng-container>
  </div>
  <div class="col-sm-6 text-end">
    <button
      class="me-1 icon-mat"
      (click)="createShipments()"
      #tooltip="matTooltip"
      [matTooltip]="'shipment.shipmentList.createOrder' | translate"
      mat-raised-button>
      <em class="bi bi-plus"></em>
    </button>

    <button
      class="me-1 icon-mat"
      (click)="uploadShipments()"
      #tooltip="matTooltip"
      [matTooltip]="'shipment.shipmentList.uploadOrder' | translate"
      mat-raised-button>
      <em class="bi bi-upload"></em>
    </button>

    <button
      class="me-1 icon-mat"
      (click)="onStatusTabChange({ index: this.selectedTabForStatus })"
      #tooltip="matTooltip"
      [matTooltip]="'shipment.shipmentList.refresh' | translate"
      mat-raised-button>
      <em class="bi bi-arrow-clockwise"></em>
    </button>

    <button
      class="icon-mat"
      (click)="openTempDialog()"
      #tooltip="matTooltip"
      [matTooltip]="'shipment.shipmentList.filter' | translate"
      mat-raised-button>
      <em class="bi bi-funnel"></em>
    </button>
  </div>
</div>

<div class="row ml-2">
  <div class="col-sm-6 no-margin mt-2 search-bar-group">
    <input
      matInput
      class="pt-2 input-search"
      [formControl]="searchKeywordFilter"
      placeholder="{{ searchPlaceHolder | translate }}" />
  </div>

  <div *ngIf="!pieceLevelLabelPrint" class="col-sm-6 text-end">
    <span [matTooltip]="tooltipTextShipmentLevel | translate" [matTooltipDisabled]="false">
      <button
        *ngIf="selectedShipment.length > 0 && this.selectedTabForStatus !== 3"
        class="ms-3 me-1 icon-mat"
        [disabled]="
          generateLabelDisable ||
          this.isVerifyGenerateLabel().breakbulkShips ||
          this.isVerifyGenerateLabel().onlyIndividualShips
        "
        (click)="generateLabelShipments()"
        matBadge="{{ selectedShipment.length }}"
        matBadgeOverlap="true"
        matBadgeSize="small"
        mat-raised-button>
        <i class="bi bi-download"></i>
      </button>
    </span>

    <button
      *ngIf="selectedShipment.length > 0 && this.selectedTabForStatus !== 2"
      class="icon-mat"
      [disabled]="deleteDisable"
      (click)="deleteShipments(this.selectedShipment)"
      [matTooltip]="'shipment.shipmentList.delete' | translate"
      mat-raised-button>
      <i class="bi bi-trash"></i>
    </button>
  </div>
  <div *ngIf="pieceLevelLabelPrint" class="col-sm-6 text-end">
    <span [matTooltip]="tooltipTextPieceLevel | translate" [matTooltipDisabled]="false">
      <button
        *ngIf="selectedPieces.length > 0 && this.selectedTabForStatus !== 1"
        class="ms-3 me-1 icon-mat"
        [disabled]="
          this.isVerifyPiecesGenerateLabel().piecesBreakbulkShips ||
          this.isVerifyPiecesGenerateLabel().piecesOnlyIndividualShips
        "
        (click)="
          this.selectedTabForStatus == 2 ? batchViewPieceLabel() : generateLabelShipments()()
        "
        matBadge="{{ selectedShipment.length }}"
        matBadgeOverlap="true"
        matBadgeSize="small"
        mat-raised-button>
        <i class="bi bi-download"></i>
      </button>
    </span>
    <span
      [matTooltip]="
        this.isVerifyPiecesViewLabel()
          ? ('shipment.shipmentList.invalidShipmentsToViewLabel' | translate)
          : ('shipment.shipmentList.viewLabel' | translate)
      "
      [matTooltipDisabled]="false">
      <button
        *ngIf="selectedShipment.length > 0 && this.selectedTabForStatus !== 2"
        class="icon-mat"
        [disabled]="generateLabelDisable || this.isVerifyPiecesViewLabel()"
        (click)="batchViewPieceLabel()"
        matBadge="{{ selectedPieces.length }}"
        matBadgeOverlap="true"
        matBadgeSize="small"
        mat-raised-button>
        <i class="bi bi-eye"></i>
      </button>
    </span>
    <button
      *ngIf="selectedShipment.length > 0 && this.selectedTabForStatus !== 2"
      class="icon-mat"
      [disabled]="deleteDisable"
      (click)="deleteShipments(this.selectedShipment)"
      [matTooltip]="'shipment.shipmentList.delete' | translate"
      mat-raised-button>
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>
<div class="row">
  <span *ngIf="manifestFailed" class="warning">
    {{ 'shipment.shipmentList.noteLabel' | translate }}
    {{ 'shipment.shipmentList.manifestFailedMsg' | translate }}</span
  >
</div>
<ng-template #dialogRef let-mydata>
  <h6>{{ 'shipment.shipmentList.advancedFilter' | translate }}</h6>
  <form [formGroup]="AdvFilterForm" (submit)="applyAdvFilter()">
    <div class="mb-1">
      <label class="col-form-label">{{ 'shipment.shipmentList.shipmentID' | translate }}:</label>
      <input type="text" class="form-control" formControlName="shipmentID" />
    </div>
    <div>
      <label class="col-form-label">{{ 'shipment.shipmentList.pID' | translate }}:</label>
      <input type="text" class="form-control" formControlName="PID" />
    </div>
    <div class="mb-1">
      <label class="col-form-label"
        >{{ 'shipment.shipmentList.customerReference' | translate }}:</label
      >
      <input type="text" class="form-control" formControlName="customerReference" />
    </div>
    <div class="mb-1">
      <label class="col-form-label">{{ 'shipment.shipmentList.receiverName' | translate }}:</label>
      <input type="text" class="form-control" formControlName="receiverName" />
    </div>
    <div class="mb-1">
      <label class="col-form-label">{{ 'shipment.shipmentList.date' | translate }}:</label>
      <mat-form-field>
        <mat-label>{{ 'shipment.shipmentList.enterDateRange' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input
            type="text"
            matStartDate
            [placeholder]="'shipment.shipmentList.startDate' | translate"
            formControlName="startDate"
            readonly />
          <input
            type="text"
            matEndDate
            placeholder="{{ 'shipment.shipmentList.endDate' | translate }}"
            formControlName="endDate"
            readonly />
        </mat-date-range-input>
        <mat-hint>{{ 'shipment.shipmentList.dateLabel' | translate }}</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <button type="submit" [disabled]="isAdvancedFilterCheck()" class="secondary-btn pull-right">
      {{ 'shipment.shipmentList.submit' | translate }}
    </button>
    <button class="primary-btn ml-2" mat-dialog-close="close" (click)="closeDialog()">
      {{ 'shipment.shipmentList.close' | translate }}
    </button>
  </form>
</ng-template>

<div class="row">
  <div class="custom-card m-2">
    <div>
      <mat-tab-group
        mat-align-tabs="start"
        [(selectedIndex)]="selectedTabForStatus"
        (selectedTabChange)="onStatusTabChange($event)">
        <mat-tab [label]="'shipment.shipmentList.new' | translate"></mat-tab>
        <mat-tab [label]="'shipment.shipmentList.labelGenerated' | translate"></mat-tab>
        <mat-tab [label]="'shipment.shipmentList.manifested' | translate"></mat-tab>
      </mat-tab-group>
    </div>

    <div class="table-container">
      <table
        aria-describedby="shipmentlist"
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="shipmentDate"
        matSortDirection="desc">
        <ng-container matColumnDef="shipmentSelected">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              *ngIf="this.selectedTabForStatus !== 3"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isEntirePageSelected()"
              [indeterminate]="selection.hasValue() && !isEntirePageSelected()"></mat-checkbox>

            <!--<mat-checkbox
              [checked]="allShipmentsSelected"
              [indeterminate]="!!selection.selected.length && !allShipmentsSelected"
              (change)="toggleMasterShipmentsSelection()">
            </mat-checkbox>-->
          </th>

          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              *ngIf="this.selectedTabForStatus !== 3"
              [checked]="selection.isSelected(element)"
              (change)="selection.toggle(element); updateSelection()"
              class="pt-2"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="shipmentID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.shipmentId' | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="openShipmentDetails(element)"
            class="td-link">
            {{ element.shipmentID }}
          </td>
        </ng-container>

        <ng-container matColumnDef="customerReference">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.customerReference' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.customerReference }}</td>
        </ng-container>
        <ng-container matColumnDef="mawbId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span *ngIf="disableSortArrowManifest()">{{
              'shipment.shipmentList.MAWB' | translate
            }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="m-0" *ngIf="disableSortArrowManifest()">
              {{ element.mawbId || element.mawb }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="dServiceCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!disableSortArrow()">
            <span class="ps-4" *ngIf="disableSortArrow()">
              {{ 'shipment.shipmentList.motherGateway' | translate }}</span
            >
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="ps-4 m-0" *ngIf="disableSortArrow()">
              {{ element.dServiceCode }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="shipmentDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span *ngIf="this.selectedTabForStatus === 0">{{
              'shipment.shipmentList.shipmentCreatedDate' | translate
            }}</span>
            <span *ngIf="this.selectedTabForStatus === 1">{{
              'shipment.shipmentList.labelGeneratedDate' | translate
            }}</span>
            <span *ngIf="this.selectedTabForStatus === 2">{{
              'shipment.shipmentList.manifestedDate' | translate
            }}</span>
          </th>

          <td mat-cell *matCellDef="let element">
            {{ element.shipmentDate | date : 'dd/MMM/yyyy hh:mm aa' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="transitDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.transitDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.transitDate !== 'n/a' || element.transitDate !== null">{{
              element.transitDate | date : 'dd/MMM/yyyy'
            }}</span>
            <span *ngIf="element.transitDate == null">Not applicable</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="shipperCompanyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.shipper' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.shipperName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="shipperCountryCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="pieceLevelLabelPrint">
            {{ 'shipment.shipmentList.origin' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.OriginCountry }}
          </td>
        </ng-container>

        <ng-container matColumnDef="pieceID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!pieceLevelLabelPrint">
            {{ 'shipment.shipmentList.pieceID' | translate }}
          </th>
          <td
            (click)="openShipmentDetails(element)"
            class="td-link"
            [ngClass]="{ 'zero-width': !pieceLevelLabelPrint }"
            mat-cell
            *matCellDef="let element">
            {{ element.pieceID }}
          </td>
        </ng-container>
        <ng-container matColumnDef="pieceReference">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!pieceLevelLabelPrint">
            <span class="ps-2">{{ 'shipment.shipmentList.pieceReference' | translate }} </span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="ps-2"> {{ element.pieceReference }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverCompanyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>{{ 'shipment.shipmentList.receiver' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.receiverName }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverCountryCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="ps-2">{{ 'shipment.shipmentList.destination' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="ps-2">{{ element.DestinationCountry }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="noOfPieces">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="ps-2">{{ 'shipment.shipmentList.noOfPieces' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="ps-2">{{ element?.noOfPieces }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="totalWeight">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="ps-2">{{ 'shipment.shipmentList.totalWeight' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="ps-2">{{ element?.totalWeight }}</span>
          </td>
        </ng-container>

        <!-- shipmentStatus -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.shipmentStatus' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="status-cell">
              <span>{{ element.shipmentStatus }}</span>
              <i
                *ngIf="element?.shipment_warning?.length"
                class="bi bi-exclamation-triangle-fill text-warning warning-icon"
                [matTooltip]="formatWarnings(element.shipment_warning)"
                matTooltipClass="tooltip-monospace"
                matTooltipShowDelay="300">
              </i>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="productCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.productCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.productCode }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="track">
          <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'shipment.shipmentList.track' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="td-link text-center">
            <a
              [href]="getTrackUrl(element)"
              style="color: inherit; text-decoration: none"
              target="_blank"
              rel="noopener noreferrer">
              <i
                class="bi bi-truck"
                [matTooltip]="
                  ('shipment.shipmentList.trackStatusShipmentID' | translate) + element.shipmentID
                "></i>
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="pieceStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>{{ 'shipment.shipmentList.pieceStatus' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span>{{ element.piece_status }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="pieceAction">
          <th class="text-center" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.shipmentList.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              *ngIf="
                pieceLevelLabelPrint &&
                element.piece_status?.toLowerCase() == 'Not Generated'.toLowerCase() &&
                (element.shipmentStatus == 'Created' ||
                  element.shipmentStatus == 'Partially Label Generated')
              "
              class="ms-3 me-1 icon-mat table-mat-icon"
              (click)="
                generateIndividualPieceLabel(
                  element.pieceID,
                  element.shipmentID,
                  element.productCode
                )
              "
              mat-raised-button
              [matTooltip]="'shipment.shipmentList.generateLabel' | translate">
              <i class="bi bi-download"></i>
            </button>
            <button
              *ngIf="
                pieceLevelLabelPrint &&
                element.piece_status?.toLowerCase() == 'Generated'.toLowerCase() &&
                (element.shipmentStatus == 'Partially Label Generated' ||
                  element.shipmentStatus == 'Label Generated' ||
                  element.shipmentStatus == 'Manifested' ||
                  element.shipmentStatus == 'Manifest Failed')
              "
              class="ms-3 me-1 icon-mat table-mat-icon"
              (click)="viewLabel(element.pieceID, element.shipmentID, element.productCode)"
              mat-raised-button
              [matTooltip]="'shipment.shipmentList.viewLabel' | translate">
              <i class="bi bi-eye"></i>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="InvoiceAction">
          <th mat-header-cell *matHeaderCellDef>Invoice</th>
          <td mat-cell *matCellDef="let element">
            <i
              *ngIf="this.nonDocProductCodes.includes(element.productCode)"
              matTooltip="{{ 'maw.mawList.uploadDocuments' | translate }}"
              class="m-1 icon-mat"
              [ngClass]="{
                'bi bi-clipboard': element.shipmentStatus === 'Created',
                'bi bi-file-earmark-arrow-up': element.shipmentStatus === 'Created'
              }"
              (click)="openUploadInvoices(element.shipmentID, element.shipmentStatus)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row text-center" *matNoDataRow>
          {{
            'shipment.shipmentList.noDataAvailable' | translate
          }}
        </tr>
      </table>
      <mat-paginator
        [pageSize]="25"
        #paginator
        [length]="totalData"
        [pageSizeOptions]="pageSizes"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
